import {
  COOKIE_EXPIRATION,
  COOKIE_NAMES,
  DEFAULT_COOKIE_OPTIONS,
} from "@constants/cookies";
import type { CookieSetOptions } from "universal-cookie";

import { safeLocalStorage } from "@lib/safeStorage";

export class CookiesService {
  static setSessionStartCookie(
    setCookie: (
      name: string,
      value: string,
      options?: CookieSetOptions,
    ) => void,
  ): void {
    setCookie(
      COOKIE_NAMES.SESSION_START,
      new Date().toISOString(),
      DEFAULT_COOKIE_OPTIONS,
    );
  }

  static setExperimentCookie(
    setCookie: (
      name: string,
      value: string,
      options?: CookieSetOptions,
    ) => void,
    experimentId: string,
    variantId: string,
  ): void {
    setCookie(
      COOKIE_NAMES.EXPERIMENT,
      `${experimentId}.${variantId}`,
      DEFAULT_COOKIE_OPTIONS,
    );
  }

  static setRememberMeCookie(
    setCookie: (
      name: string,
      value: string,
      options?: CookieSetOptions,
    ) => void,
    value: boolean,
  ): void {
    setCookie(COOKIE_NAMES.REMEMBER_ME, value.toString(), {
      ...DEFAULT_COOKIE_OPTIONS,
      expires: value ? COOKIE_EXPIRATION.NEVER : COOKIE_EXPIRATION.SESSION,
    });
  }

  static cleanupLegacyStorage(): void {
    safeLocalStorage.removeItem("si");
    safeLocalStorage.removeItem("ck");
  }
}
